export default "__VITE_ASSET__5URJ9D4f__"